const breakpoints = {
    xs: '480px',
    sm: '768px',
    md: '1024px',
    lg: '1366px',
    xl: '1920px'
};

const breakpointsInt = {
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1366,
    xl: 1920
};

const breakpointsMaterialUi = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1366,
    xl: 1920
};

// Max-width bands for the Awareness Raiser pages only. The sets above are min-width.
const awarenessBreakpoints = {
    w560: '560px',
    w600: '600px',
    w640: '640px',
    w820: '820px',
    w860: '860px',
    w900: '900px'
};


export { breakpoints, breakpointsInt, breakpointsMaterialUi, awarenessBreakpoints };